"use strict";

exports.__esModule = true;
var _PlainText = require("./PlainText");
Object.keys(_PlainText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlainText[key]) return;
  exports[key] = _PlainText[key];
});